module.exports = __webpack_public_path__ + "img/priscila-camargo.0ad1a43c.png";